import React, {
    useEffect,
    useRef,
    useState
} from "react";
import Footer from "./footer";
import Navbar from "./Navbar_prod";
import usePageContent from "../hooks/usePageContent";

import { useLocation } from "react-router-dom";

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) {
            window.scrollTo(0, 0);
            return;
        }

        const id = location.hash.substring(1);

        const timer = setTimeout(() => {
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        }, 200);

        return () => clearTimeout(timer);
    }, [location.pathname, location.hash]);

    return null;
};



const MainLayout = ({ children }) => {
    const { get } = usePageContent("home");

    return (
        <div className="main-layout">

            <ScrollToSection />

            <Navbar data={get("navbar")} />

            <main>
                {children}
            </main>

            <Footer data={get("footer")} />

        </div>
    );
};

export default MainLayout;